// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6136b1e3","239":"c5ebafd4","455":"6921a52c"}[chunkId] + ".chunk.js";
};